

function createMarkup(data) {

    return { __html: data }
}
export default createMarkup